<template>
  <b-card>
    <!-- form -->
    <validation-observer ref="profilePasswordForm">
      <b-form ref="profilePasswordFormElement" @submit.prevent="save">
        <b-row>
          <!-- old password -->
          <b-col md="6">
            <b-form-group :label="t('Old Password')" label-for="old-password">
              <validation-provider
                #default="{ errors }"
                :name="t('Old Password')"
                rules="required"
                vid="oldPassword"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="password"
                    v-model="passwordValueOld"
                    :type="passwordFieldTypeOld"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false : null"
                    name="old-password"
                    :placeholder="t('Password')"
                  />

                  <b-input-group-append is-text>
                    <feather-icon
                      :icon="passwordToggleIconOld"
                      class="cursor-pointer"
                      @click="togglePasswordOld"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!--/ old password -->
        </b-row>
        <b-row>
          <!-- new password -->
          <b-col md="6">
            <b-form-group :label="t('New Password')" label-for="new-password">
              <validation-provider
                #default="{ errors }"
                :name="t('New Password')"
                rules="required|uppercase_and_digit|min:6"
                vid="newPassword"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="new-password"
                    v-model="newPasswordValue"
                    :type="passwordFieldTypeNew"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false : null"
                    name="old-password"
                    :placeholder="t('Password')"
                  />

                  <b-input-group-append is-text>
                    <feather-icon
                      :icon="passwordToggleIconNew"
                      class="cursor-pointer"
                      @click="togglePasswordNew"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- new password -->
          <b-col md="6">
            <b-form-group label-for="retype-new-password" :label="t('Retype New Password')">
              <validation-provider
                #default="{ errors }"
                :name="t('Retype New Password')"
                rules="required|confirmed:newPassword"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="retype-new-password"
                    v-model="RetypePassword"
                    :type="passwordFieldTypeRetype"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false : null"
                    name="retype-new-password"
                    :placeholder="t('Retype New Password')"
                  />

                  <b-input-group-append is-text>
                    <feather-icon
                      :icon="passwordToggleIconRetype"
                      class="cursor-pointer"
                      @click="togglePasswordRetype"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!--/ new password -->

          <!-- buttons -->
          <b-col cols="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mt-1 mr-1"
              type="submit"
              :disabled="requestIsLoading"
            >
              {{ requestIsLoading ? t('Loading') : t('Save Changes') }}
            </b-button>
            <b-button variant="secondary" class="mt-1 mr-1" type="button" @click="resetForm">
              {{ t('Reset') }}
            </b-button>
          </b-col>
          <!--/ buttons -->
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BCard,
  BInputGroup,
  BInputGroupAppend
} from 'bootstrap-vue';
import Ripple from 'vue-ripple-directive';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, email, confirmed, password, uppercase_and_digit } from '@validations';
import { helper } from '@core/mixins/helper.js';
import useService from '@/auth/service/useService';

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver
  },
  directives: {
    Ripple
  },
  mixins: [helper],
  data() {
    return {
      passwordValueOld: '',
      newPasswordValue: '',
      RetypePassword: '',
      passwordFieldTypeOld: 'password',
      passwordFieldTypeNew: 'password',
      passwordFieldTypeRetype: 'password',
      required,
      email,
      confirmed,
      password,
      uppercase_and_digit,
      requestIsLoading: false
    };
  },
  computed: {
    passwordToggleIconOld() {
      return this.passwordFieldTypeOld === 'password' ? 'EyeIcon' : 'EyeOffIcon';
    },
    passwordToggleIconNew() {
      return this.passwordFieldTypeNew === 'password' ? 'EyeIcon' : 'EyeOffIcon';
    },
    passwordToggleIconRetype() {
      return this.passwordFieldTypeRetype === 'password' ? 'EyeIcon' : 'EyeOffIcon';
    }
  },
  methods: {
    togglePasswordOld() {
      this.passwordFieldTypeOld = this.passwordFieldTypeOld === 'password' ? 'text' : 'password';
    },
    togglePasswordNew() {
      this.passwordFieldTypeNew = this.passwordFieldTypeNew === 'password' ? 'text' : 'password';
    },
    togglePasswordRetype() {
      this.passwordFieldTypeRetype =
        this.passwordFieldTypeRetype === 'password' ? 'text' : 'password';
    },
    resetForm() {
      this.passwordValueOld = '';
      this.newPasswordValue = '';
      this.RetypePassword = '';
    },
    save() {
      const userData = this.$store.state.auth.user;

      if (userData && userData.id) {
        this.requestIsLoading = true;
        this.$refs.profilePasswordForm.validate().then(success => {
          if (success) {
            useService
              .updatePassword({
                oldPassword: this.passwordValueOld,
                newPassword: this.newPasswordValue,
                newPasswordAgain: this.RetypePassword
              })
              .then(response => {
                this.$refs.profilePasswordFormElement.reset();
                this.showSuccessMessage(
                  `${response.message || this.$t('Password Success Message')}`
                );
              })
              .catch(messages => {
                if (typeof messages === 'object' && messages && messages.length) {
                  messages.forEach(item => {
                    this.showErrorMessage(item.message);
                  });
                }
              })
              .finally(() => {
                this.requestIsLoading = false;
              });
          }
        });
      }
    }
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
